export default "__VITE_ASSET__BHUSTW56__"